qw-room-list-card {
  --qw-room-list-card-gap: var(--qw-hotel-gap-sm);
  --qw-room-list-card-background: var(--qw-hotel-background);
  --qw-room-list-card-border-radius: 2px;

  display: flex;
  flex-direction: column;
  padding: var(--qw-room-list-card-gap);
  background: var(--qw-room-list-card-background);
  border-radius: var(--qw-room-list-card-border-radius);
  width: 100%;
}

qw-room-list-card h4, qw-room-list-card h6 {
  margin: 0; padding: 0;
}

qw-room-list-card.qw-room-list-card__disabled, qw-room-list-card.qw-room-list-card__is-loading {
  opacity: var(--qw-hotel-opacity);
  pointer-events: none !important;
}

qw-room-list-card qw-card {
  display: grid;
  grid-template-columns: repeat(2, minmax(var(--qw-room-rate--card--min-width), 1fr));
  grid-template-rows: repeat(5, auto);
  width: 100%;
  height: auto;
}

qw-room-list-card.qw-room-list-card--grid qw-card {
  display: flex;
  flex-flow: column;
}

qw-room-list-card qw-card > div {
  margin: calc(var(--qw-hotel-gap-sm) / 2);
}

qw-room-list-card .qw-room-list-card__image {
  grid-column: 1 / 2;
  grid-row: 1 / 6;
}

qw-room-list-card .qw-room-list-card__image img {
  width: 100%;
}

.qw-room-list-card__title-content,
.qw-room-list-card__image,
qw-room-list-card qw-price {
  cursor: pointer;
}

qw-room-list-card .qw-room-list-card__title,
qw-room-list-card .qw-room-list-card__descriptions,
qw-room-list-card .qw-room-list-card__prices,
qw-room-list-card .qw-room-list-card__cta,
qw-room-list-card .qw-room-list-card__basket-actions {
  grid-column: 2 / 2;
}

qw-room-list-card .qw-room-list-card__title {
  display: flex;
  justify-content: space-between;
  grid-row: 1 / 2;
}
qw-room-list-card .qw-room-list-card__title-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
qw-room-list-card .qw-room-list-card__descriptions {
  grid-row: 2 / 3;
}
qw-room-list-card .qw-room-list-card__prices {
  grid-row: 3 / 4;
}
qw-room-list-card .qw-room-list-card__basket-actions {
  grid-row: 4 / 5;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
qw-room-list-card .qw-room-list-card__cta {
  grid-row: 5 / 6;
  align-self: end;
  width: 100%;
  display: flex;
  justify-content: space-evenly;
}
qw-room-list-card .qw-room-list-card__prices-with-taxes {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
qw-room-list-card .qw-room-list-card__basket-actions-counter-label {
  font-size: 70%;
}
qw-room-list-card .qw-room-list-card__room-taxes {
  font-size: var(--qw-hotel-small-font-size);
}

qw-room-list-card.qw-room-list-card--card .qw-room-list-card__title,
qw-room-list-card.qw-room-list-card--card .qw-room-list-card__image,
qw-room-list-card.qw-room-list-card--card .qw-room-list-card__descriptions,
qw-room-list-card.qw-room-list-card--card .qw-room-list-card__cta {
  grid-column: 1 / 2;
}

qw-room-list-card.qw-room-list-card--card .qw-room-list-card__image {
  grid-row: 2 / 3;
}

qw-room-list-card.qw-room-list-card--card .qw-room-list-card__descriptions {
  display: none;
}

qw-room-list-card.qw-room-list-card--card .qw-room-list-card__cta {
  grid-row: 3 / 4;
}

qw-room-list-card.qw-room-list-card--card .qw-room-list-card__rates {
  grid-column: 2 / 2;
  grid-row: 1 / 3;
}

qw-room-list-card.qw-room-list-card--card .qw-room-list-card__prices {
  grid-column: 2 / 2;
  grid-row: 3 / 4;
}


.qw-room-list-card__details-popup-wrapper {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 99;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, .5);
}

.qw-room-list-card__details-popup-content {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  background-color: var(--qw-hotel-neutral-lightest);
  width: 90%;
  max-width: 1680px;
  height: auto;
  max-height: 90vh;
  padding: var(--qw-hotel-gap-lg);
}

.qw-room-list-card__details-popup-content .content-info__room-details h3, .qw-room-list-card__details-popup-content .content-info__services h3 {
  font-family: var(--qw-hotel-font-family);
  font-size: 20px;
}

.qw-room-list-card__details-popup-content .qw-room-base-info-list {
  margin: 18px 0 54px;
  display: block;
  padding: 0;
  width: 100%;
}
.qw-room-list-card__details-popup-content .content-info__services {
  width: 100%;
  flex-wrap: wrap;
}

.qw-room-list-card__details-popup-content .qw-room-base-info-list:last-of-type {
  margin-bottom: 0;
}

.qw-room-list-card__details-popup-content .qw-room-base-info-list li {
  min-width: 25%;
  padding-right: 60px;
}

.qw-room-list-card__details-popup-content .qw-room-base-info-list li p {
  margin: 0;
}

.qw-room-list-card__details-popup-content .close-icon {
  position: absolute;
  top: var(--qw-hotel-gap-sm);
  right: var(--qw-hotel-gap-sm);
  width: 30px;
  height: 30px;
  margin: var(--qw-hotel-gap-lg);
  z-index: 100;
  background: url('https://joandjoestg.wpengine.com/jj-booking-engine-components/img/icons/close.svg') no-repeat center;
  background-size: contain;
  cursor: pointer;
}

.qw-room-list-card__details-popup-content .content-info {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: flex-start;
  width: 60%;
  padding-right: 40px;
}


.qw-room-list-card__details-popup-content .content-info h2 + p {
  margin: 27px 0 41px;
}

.qw-room-list-card__details-popup-content .content-carousel {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50%;
  max-width: 500px;
}

.qw-room-base-info__item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.qw-room-base-info__item .icon {
  display: block;
  width: 70px;
  height: 60px;
  border-radius: 50%;
  margin-right: var(--qw-hotel-gap-sm);
}
